import isNumber from 'lodash/isNumber';

export var NUMERIC_TYPE = 'numeric';

/**
 * Используем везде пиксели
 * @type {String}
 */
export var DEFAULT_UNIT = 'px';

/**
 * Размер в цифрах
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-numeric-size.json
 * @param {Number} data.value
 * @param {Number} defaultValue.value
 * @return {Object}
 */
export default (function (data) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (!data || data.type !== NUMERIC_TYPE) {
        return defaultValue;
    }

    if (isNumber(data.value) && !isNaN(data.value)) {
        return numericSizeFactory(data.value);
    }

    return defaultValue;
});

/**
 * @param {Number} value
 * @param {String} unit
 * @return {NumericSize}
 */
export var numericSizeFactory = function numericSizeFactory() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_UNIT;
    return {
        value: value,
        unit: unit,
        type: NUMERIC_TYPE
    };
};

export var ZERO = numericSizeFactory();